
export const MenuBtn =({activeMenu})=>{
    return(
        <>
            <svg  className="h-[20px] sm:h-[32px]"  viewBox="0 0 56 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M51.3907 13.5059H0.999878L4.67804 1.00011H55.0688L51.3907 13.5059Z" fill={activeMenu? "#141414" : "white" } stroke={activeMenu? "white" : "#F6F6F6"}/>
                <path d="M51.3907 34.0117H0.999878L4.67804 21.506H55.0688L51.3907 34.0117Z" fill={activeMenu? "#141414" : "white" } stroke={activeMenu? "white" : "#F6F6F6"}/>
            </svg>
        </>
    )
}